var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('global-layout',[_c('transition',{attrs:{"name":"page-transition"}},[(_vm.keepAlive)?_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1):_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }